const formUpdater = (
  // input event
  e = { target: {} },

  // react useState first value
  form = {},

  // react useState second value
  setForm = () => {}
) => {
  setForm({
    ...form,
    [e.target.name]: e.target.value
  })
}

export { formUpdater }